/* global modUtils */
import { trackFormSubmissionFlow } from '../../helpers';
export function getHSGeoLookupDetails() {
	let data = {};

	if (window.geolocation) {
		trackFormSubmissionFlow({ inGetHSGeoLookupDetails: true });
		const { geo } = modUtils.getUrlParamsToObject();
		const { responseCollection, source, usedSource } = window.geolocation;

		if (responseCollection) {
			data = responseCollection;
		}

		if (responseCollection.maxmind) {
			const maxmind = responseCollection.maxmind;
			const filteredMaxmindObj = {
				city: maxmind.city?.names?.en || undefined,
				postalCode: maxmind.postal?.code || undefined,
				subdivision: maxmind.subdivisions?.[0]?.names?.en || undefined
			};

			data.maxmind = filteredMaxmindObj;
		}

		if (geo) {
			data.geo = geo;
		}

		if (source || usedSource) {
			data.usedSource = usedSource || source;
		}
	}

	return data;
}
